import React from 'react';
import './StatsCard.css';

const StatsCard = ({ title, count, value, color, icon }) => {
  return (
    <div className={`stats-card stats-card-${color}`}>
      <div className="stats-card-header">
        <span className="stats-card-icon">{icon}</span>
        <h3 className="stats-card-title">{title}</h3>
      </div>
      <div className="stats-card-content">
        <div className="stats-card-count">
          <div className="metric-value">{count}</div>
          <div className="metric-label">Usuarios</div>
        </div>
        <div className="stats-card-value">
          <div className="metric-value">€{value}</div>
          <div className="metric-label">Total EUR</div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
